<div class="headerdiv">
  <div>
    <h3 class="pagetitle">Pending Events</h3>
    <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
  </div>

</div>

  <!-- <div style="margin-left: 20px; margin-top: 20px;">
    <form class="sortingdiv" [formGroup]="sortForm">
      <label class="sortbylabel">Sort By:</label>
      <mat-form-field appearance="outline">
        <mat-select enableeOptionCentering formControlName="sort">
          <mat-option>

          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div> -->

  <div style="padding: 30px">
  <div class="row">
      <div class="pendingeventdiv" *ngFor="let el of allPendingEvents; let i = index">
        <p class="eventtitle">{{el.event_name}}</p>
        <img routerLink='/admin/detailedevent' (click)="saveEvent(el)" class="eventimg"
          src="https://events.globalistic.tech{{el.images[0].filename}}">
        <div class="row">
          <div class="col option1">
            Event ID
          </div>
          <div class="col">
            {{el.id}}
          </div>
        </div>
        <div class="row">
          <div class="col option1">
            Organizer
          </div>
          <div class="col">
            {{el.user.first_name}} {{el.user.last_name}}
          </div>
        </div>
        <div class="row">
          <div class="col option1">
            Email
          </div> 
          <div class="col">
            <a matTooltip="{{el.user.email}}" href="mailto:{{el.user.email}}"><span class="material-icons emailicon">mail</span></a>
          </div>
        </div>
        <div class="row">
          <div class="col option1">
            Address
          </div>
          <div class="col">
            {{el.location}}
          </div>
        </div>
        <div class="row">
          <div class="col option1">
            Date
          </div>
          <div class="col">
            {{el.event_dates[0].date | date: 'MMM dd,yyyy HH:mm'}}
          </div>
        </div>
        <div class="row">
          <div class="col option1">
            Fees
          </div>
          <div class="col">
            {{el.freeEvent}}
          </div>
        </div>
        <!-- <div class="row">
          <div class="col option1">
            Country
          </div>
          <div class="col">
            {{el.country_list.countryname}}
          </div>
        </div> -->
        <div class="row divfooter">
          <div class="col">
            <mat-icon (click)="acceptEvent(el.id)" class="accept">done</mat-icon>
          </div>
          <div class="col">
            <mat-icon (click)="showCancellation(el.id)" class="reject">close</mat-icon>
          </div>
        </div>
      </div> 
    </div>
  </div>



<!-- Cancellation Reason Modal -->

<div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Reject Event</h4>
        <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
          class="material-icons">highlight_off</i>

      </div>
      <div style="display: inline-block;">

        <div class="modal-body">
          <!-- <mat-form-field style="width: 100%;" appearance="outline" [formGroup]="message">
            <mat-label>Message*</mat-label>
            <textarea matInput formControlName="message"></textarea>
          </mat-form-field> -->
          <mat-label>Are you sure you want to reject this event?</mat-label>

          <button (click)="rejectEvent()" class="confirmcancellation">Confirm Rejection</button>
        </div>
        <div class="modal-footer">

        </div>
      </div>
    </div>
  </div>
</div>
